import { render, staticRenderFns } from "./EntranceInfomeation.vue?vue&type=template&id=22957f30&scoped=true&lang=pug&"
import script from "./EntranceInfomeation.vue?vue&type=script&lang=ts&"
export * from "./EntranceInfomeation.vue?vue&type=script&lang=ts&"
import style0 from "./EntranceInfomeation.vue?vue&type=style&index=0&id=22957f30&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22957f30",
  null
  
)

export default component.exports